import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { assetUrl } from '@/utils/asset-url';

const LoadingPortal = ({ isLoading }) => {
  if (!isLoading) return null;

  return ReactDOM.createPortal(
    <div className="modal white">
      <div className="loading">
        <img src={assetUrl("/img/loading.gif")} alt="Loading..." />
      </div>
    </div>,
    document.body
  );
};

LoadingPortal.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default LoadingPortal;
